/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAllTargets } from '../../actions/targetActions';
import {
  addWorkPackageToTarget,
  removeWorkPackageFromTarget
} from '../../actions/workPackageActions';
import { filterTargetsBySpace } from '../../selectors/targetSelector';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import CustomSelect from './CustomSelect/SelectField';

class TargetSelect extends React.Component {
  componentDidMount() {
    if (!this.props.targetList) this.props.getAllTargets();
  }

  onChange = (option) => {
    if (option.value === this.props.selected) return;
    const { workPackage } = this.props;
    if (option.value === -1)
      this.props.removeWorkPackageFromTarget(workPackage.id);
    else this.props.addWorkPackageToTarget(workPackage.id, option.value);
  };

  handleSelection = (option) => {
    if (option.value === this.props.selected) return;
    this.props.onSelect(option.value, 'target_id');
  };

  render() {
    const { disabled, label, targetList, selected, workPackage } = this.props;

    const onChange = workPackage.id ? this.onChange : this.handleSelection;

    let targets = targetList;
    let selectedTargetDoneOrLive = false;
    const selectedTarget = targetList.find((f) => f.id === selected);

    if (selectedTarget) {
      selectedTargetDoneOrLive =
        selectedTarget.status === WorkPackageStatuses.ACCEPTED ||
        selectedTarget.status === WorkPackageStatuses.LIVE;

      if (!selectedTargetDoneOrLive)
        targets = targetList.filter(
          (t) =>
            t.status !== WorkPackageStatuses.ACCEPTED &&
            t.status !== WorkPackageStatuses.LIVE
        );
    } else {
      targets = targetList.filter(
        (t) =>
          t.status !== WorkPackageStatuses.ACCEPTED &&
          t.status !== WorkPackageStatuses.LIVE
      );
    }

    if (!targets.length) return null;

    const defaultOption = { label: 'Choose Target', value: -1 };

    const targetOptions = targets.map((target) => ({
      label: target.short_name,
      value: target.id
    }));
    targetOptions.unshift(defaultOption);

    const selectedOption = targetOptions.find(
      (option) => option.value === selected
    );

    if (!selectedOption) {
      onChange(defaultOption);
    }
    return (
      <div className="target-select">
        {label && <label htmlFor="target">{label}</label>}
        <CustomSelect
          selectedOption={selectedOption || defaultOption}
          handleOptionChange={onChange}
          disabled={disabled || selectedTargetDoneOrLive}
          options={targetOptions}
          placeholder=""
        />
      </div>
    );
  }
}

TargetSelect.propTypes = {
  selected: PropTypes.number,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  targetList: PropTypes.array,
  onSelect: PropTypes.func,
  getAllTargets: PropTypes.func,
  workPackage: PropTypes.object
};

TargetSelect.defaultProps = {
  selected: -1,
  workPackage: {}
};

const mapStateToProps = (state) => ({
  targetList: filterTargetsBySpace(state)
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getAllTargets, addWorkPackageToTarget, removeWorkPackageFromTarget },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TargetSelect);
